import type { AnyID, Item } from '@types'
import { Vector3 } from 'three'

/** Activa logs de arrastre puff. En consola: `window.__POUFF_DRAG_DEBUG__ = true` */
export const isPouffDragDebugEnabled = (): boolean => {
  if (typeof window === 'undefined') return false
  const w = window as Window & { __POUFF_DRAG_DEBUG__?: boolean }
  return w.__POUFF_DRAG_DEBUG__ !== false && import.meta.env.DEV
}

let lastLogMs = 0
const THROTTLE_MS = 120

export function isRinconero166Catalog(catalogID: unknown): boolean {
  const base = String(catalogID ?? '')
    .trim()
    .toLowerCase()
    .split(/\s/)[0]
  return base.startsWith('166-') || /^166\d/.test(base)
}

export function vec3Label(v: Vector3): { x: number; y: number; z: number } {
  return {
    x: Math.round(v.x * 10) / 10,
    y: Math.round(v.y * 10) / 10,
    z: Math.round(v.z * 10) / 10,
  }
}

export function itemCatalogLabel(item: Item | undefined): string {
  if (!item) return '?'
  return String(item.catalogID ?? '?')
}

export function pouffDragLog(
  event: string,
  data?: Record<string, unknown>,
  options?: { force?: boolean; always?: boolean },
): void {
  if (!isPouffDragDebugEnabled()) return
  if (!options?.always) {
    const now = performance.now()
    if (!options?.force && now - lastLogMs < THROTTLE_MS) return
    lastLogMs = now
  }
  if (data) {
    console.log(`[PouffDrag] ${event}`, data)
  } else {
    console.log(`[PouffDrag] ${event}`)
  }
}

export function pouffDragWarn(
  event: string,
  data?: Record<string, unknown>,
): void {
  if (!isPouffDragDebugEnabled()) return
  console.warn(`[PouffDrag] ${event}`, data ?? '')
}

export function hasRinconero166Nearby(
  items: Map<AnyID, Item>,
  collisionableIds: Set<AnyID>,
  excludeId: AnyID,
): boolean {
  for (const otherId of collisionableIds) {
    if (otherId === excludeId) continue
    const other = items.get(otherId)
    if (other && isRinconero166Catalog(other.catalogID)) return true
  }
  return false
}
